<template>
  <div>
    <div class="container">
      <div class="title">We're sorry</div>
      <div
        class="sub-info">This feature is only available in Chinese version. You can save or share the file by "open" or "open in another way" option.
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    created() {
    }
  }
</script>


<style>
  .container {
    margin-top: 240px;
  }

  .container .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .container .sub-info {
    margin-top: 16px;
    padding: 0 16px;
    font-size: 14px;
    text-align: center;
  }
</style>
